import React from "react";
import { MeasureRule } from "./MeetLat";

/** Donker paneel: het merkanker van een scherm. Binnenrand en zacht verloop geven diepte. */
export function InkPanel({ rule = true, padding = "var(--ruimte-8)", style, children }) {
  return (
    <div style={{ position: "relative", borderRadius: "var(--radius-vlak)", overflow: "hidden",
      background: "var(--ink)", color: "var(--text-inverse)",
      boxShadow: "var(--rand-binnen-licht), var(--schaduw-2)", ...style }}>
      <div aria-hidden="true" style={{ position: "absolute", inset: 0, background: "var(--paneel-verloop)", pointerEvents: "none" }} />
      <div style={{ position: "relative", padding }}>{children}</div>
      {rule ? <MeasureRule height={10} spacing={7} accent="rgba(247,249,250,.28)" /> : null}
    </div>
  );
}
